/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_PlayersInputs */



/**
* | output |
* | --- |
* | "3rd Party Player Support (Vimeo, and YouTube)" |
*
* @param {Signup_Compare_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_players = /** @type {((inputs?: Signup_Compare_PlayersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_PlayersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "de") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "it") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "es") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
	return /** @type {LocalizedString} */ ("3rd Party Player Support (Vimeo, and YouTube)")
});